import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import Loader from "react-loaders";
import ReactTable from "react-table";
import ExportCSV from "../ExportCSV";
import { formatDateWithTime } from "../utility";
import cx from "classnames";
import { DEFAULT_PAGE_SIZE, MIN_ROW, PAGE_SIZE_OPTIONS } from "../../config/table";
import {withFixedColumnsScrollEvent, withFixedColumnsStickyPosition} from "react-table-hoc-fixed-columns";
import Pagination from './Pagination';

const ReactTableFixedColumns = withFixedColumnsStickyPosition(ReactTable);

const CustomTable = ({
  columns,
  dataSource = [],
  showPagination,
  className,
  filterable = true,
  loading,
  getTrProps,
  t,
  flexiableDefaultColsWidth,
  isExportCSV,
  setIsExportCSV,
  pageName,
  useCusomCol = true,
  style = {},
  paginationText,
  isSmallSize,
}) => {
  const ref = useRef(null);
  const [column, setColumn] = useState([]);
  const defaultColumns = [
    {
      Header: t("UserInput"),
      accessor: "userI",
      ...(flexiableDefaultColsWidth ? { minWidth: 130 } : { width: 130 }),
      Cell: ({ value }) => (
        <div
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {value || ""}
        </div>
      ),
    },
    {
      Header: t("TimeInput"),
      accessor: "inTime",
      ...(flexiableDefaultColsWidth ? { minWidth: 150 } : { width: 150 }),
      filterable: false,
      Cell: ({ value }) => (value ? formatDateWithTime(new Date(value)) : ""),
    },
    {
      Header: t("UserUpdate"),
      accessor: "userU",
      ...(flexiableDefaultColsWidth ? { minWidth: 150 } : { width: 150 }),
      Cell: ({ value }) => (
        <div
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {value || ""}
        </div>
      ),
    },
    {
      Header: t("TimeUpdate"),
      accessor: "updateTime",
      ...(flexiableDefaultColsWidth ? { minWidth: 150 } : { width: 150 }),
      filterable: false,
      Cell: ({ value }) => (value ? formatDateWithTime(new Date(value)) : ""),
    },
  ];
  useEffect(() => {
    let customColumns = columns.filter((column) => !column.isHiddenColumn);
    // defaultColumns.forEach((item) => {
    //   customColumns.splice(customColumns.length - 1, 0, item);
    // });
    setColumn([
      ...(customColumns || []),
      ...(useCusomCol ? defaultColumns : []),
    ]);
  }, [columns]);
  return (
    <>
      {isExportCSV && (
        <ExportCSV
          t={t}
          open={isExportCSV}
          setOpen={setIsExportCSV}
          columns={column}
          isUseDefaultSeq
          dataSource={
            ref && ref.current ? ref.current.getResolvedState().sortedData : []
          }
          notExportCols={[]}
          fileName={pageName}
        />
      )}
      <ReactTableFixedColumns
        innerRef={ref}
        columns={column}
        data={dataSource}
        style={style}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        pageSizeOptions={PAGE_SIZE_OPTIONS}
        minRows={MIN_ROW}
        showPagination={showPagination}
        className={cx("-striped", className)}
        filterable={filterable}
        loading={loading}
        loadingText={<Loader type="ball-pulse-rise" />}
        rowsText={(paginationText || {}).rowsText ?? ("dòng")}
        ofText={(paginationText || {}).in ?? ("/")}
        pageText={(paginationText || {}).page ?? ("Trang")}
        previousText={(paginationText || {}).prev ?? ("Trang trước")}
        nextText={(paginationText || {}).next ?? ("Trang sau")}
        noDataText={("Không có dữ liệu")}
        getTrProps={getTrProps}
        PaginationComponent={(other) => <Pagination isSmallSize={isSmallSize} {...other} />}
        // getTdProps={(state, rowInfo, column) => ({
        //   style: {
        //     height: "44px",
        //   },
        // })}
        defaultFilterMethod={(filter, row) => {
          const id = filter.id;
          if (typeof filter.value === "object") {
            return row[id] !== undefined
              ? filter.value.indexOf(row[id]) > -1
              : true;
          } else if (typeof filter.value === "string") {
            return row[id] !== undefined && row[id] !== null
              ? String(row[id].toString().toLowerCase()).indexOf(
                  filter.value.toString().toLowerCase()
                ) > -1
              : false; // Các cột có giá trị undefined hoặc null sẽ không hiển thị khi filter
          }
        }}
      />
    </>
  );
};

export default withTranslation(["configure"])(CustomTable);
